var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex"},[_c('div',{staticClass:"branding flex"},[_c('img',{attrs:{"src":require("@/assets/file-invoice-dollar-solid.png"),"alt":""}})])])
}]

export { render, staticRenderFns }